import { render, staticRenderFns } from "./HeroesListCategory.vue?vue&type=template&id=39a046e6&"
import script from "./HeroesListCategory.vue?vue&type=script&lang=js&"
export * from "./HeroesListCategory.vue?vue&type=script&lang=js&"
import style0 from "./HeroesListCategory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports